// source: command_public_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var package_proto_pb = require('./package_proto_pb.js');
goog.object.extend(proto, package_proto_pb);
goog.exportSymbol('proto.ActivityCommand', null, global);
goog.exportSymbol('proto.ActivityStatus', null, global);
goog.exportSymbol('proto.BatteryCommand', null, global);
goog.exportSymbol('proto.ButtonFunction', null, global);
goog.exportSymbol('proto.ChargeStatus', null, global);
goog.exportSymbol('proto.CommandType', null, global);
goog.exportSymbol('proto.FirmwareFlavor', null, global);
goog.exportSymbol('proto.HardwareFlavor', null, global);
goog.exportSymbol('proto.HotspotDisconnectedCommand', null, global);
goog.exportSymbol('proto.InfoCommand', null, global);
goog.exportSymbol('proto.LogCommand', null, global);
goog.exportSymbol('proto.LogCommandLevel', null, global);
goog.exportSymbol('proto.MeshCmdDataType', null, global);
goog.exportSymbol('proto.MeshCmdTypeTriggeredReport', null, global);
goog.exportSymbol('proto.MeshVersion', null, global);
goog.exportSymbol('proto.MobileConnectionQualityCommand', null, global);
goog.exportSymbol('proto.Parcel', null, global);
goog.exportSymbol('proto.ParcelChannel', null, global);
goog.exportSymbol('proto.ParcelErrorCode', null, global);
goog.exportSymbol('proto.ParcelRetry', null, global);
goog.exportSymbol('proto.ParcelStatus', null, global);
goog.exportSymbol('proto.PowerStatus', null, global);
goog.exportSymbol('proto.QualityCommand', null, global);
goog.exportSymbol('proto.RadioBandwidth', null, global);
goog.exportSymbol('proto.RadioDataRateParameters', null, global);
goog.exportSymbol('proto.RadioMode', null, global);
goog.exportSymbol('proto.RadioPowerMode', null, global);
goog.exportSymbol('proto.RadioRegion', null, global);
goog.exportSymbol('proto.RadioSpreadFactor', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Parcel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Parcel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Parcel.displayName = 'proto.Parcel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.LogCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.LogCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.LogCommand.displayName = 'proto.LogCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.QualityCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.QualityCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.QualityCommand.displayName = 'proto.QualityCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MobileConnectionQualityCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MobileConnectionQualityCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MobileConnectionQualityCommand.displayName = 'proto.MobileConnectionQualityCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BatteryCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.BatteryCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.BatteryCommand.displayName = 'proto.BatteryCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InfoCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.InfoCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InfoCommand.displayName = 'proto.InfoCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ActivityCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ActivityCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ActivityCommand.displayName = 'proto.ActivityCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.HotspotDisconnectedCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.HotspotDisconnectedCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.HotspotDisconnectedCommand.displayName = 'proto.HotspotDisconnectedCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.RadioDataRateParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.RadioDataRateParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.RadioDataRateParameters.displayName = 'proto.RadioDataRateParameters';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Parcel.prototype.toObject = function(opt_includeInstance) {
  return proto.Parcel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Parcel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Parcel.toObject = function(includeInstance, msg) {
  var f, obj = {
pb_package: (f = msg.getPackage()) && package_proto_pb.Package.toObject(includeInstance, f),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
timeout: jspb.Message.getFieldWithDefault(msg, 4, 0),
collapseKey: jspb.Message.getFieldWithDefault(msg, 5, 0),
priority: jspb.Message.getFieldWithDefault(msg, 6, 0),
sendQuality: jspb.Message.getFieldWithDefault(msg, 7, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
retry: jspb.Message.getFieldWithDefault(msg, 9, 0),
compositeId: jspb.Message.getFieldWithDefault(msg, 10, 0),
channel: jspb.Message.getFieldWithDefault(msg, 11, 0),
timestampMillis: jspb.Message.getFieldWithDefault(msg, 12, 0),
errorCode: jspb.Message.getFieldWithDefault(msg, 13, 0),
backhaulId: jspb.Message.getFieldWithDefault(msg, 14, 0),
flags: jspb.Message.getFieldWithDefault(msg, 15, 0),
requestedChannels: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Parcel}
 */
proto.Parcel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Parcel;
  return proto.Parcel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Parcel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Parcel}
 */
proto.Parcel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new package_proto_pb.Package;
      reader.readMessage(value,package_proto_pb.Package.deserializeBinaryFromReader);
      msg.setPackage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.ParcelStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimeout(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCollapseKey(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriority(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSendQuality(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimestamp(value);
      break;
    case 9:
      var value = /** @type {!proto.ParcelRetry} */ (reader.readEnum());
      msg.setRetry(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompositeId(value);
      break;
    case 11:
      var value = /** @type {!proto.ParcelChannel} */ (reader.readEnum());
      msg.setChannel(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimestampMillis(value);
      break;
    case 13:
      var value = /** @type {!proto.ParcelErrorCode} */ (reader.readEnum());
      msg.setErrorCode(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBackhaulId(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFlags(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestedChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Parcel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Parcel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Parcel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Parcel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      package_proto_pb.Package.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTimeout();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getCollapseKey();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getSendQuality();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getRetry();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCompositeId();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTimestampMillis();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getErrorCode();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getBackhaulId();
  if (f !== 0) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = message.getFlags();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getRequestedChannels();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
};


/**
 * optional Package package = 1;
 * @return {?proto.Package}
 */
proto.Parcel.prototype.getPackage = function() {
  return /** @type{?proto.Package} */ (
    jspb.Message.getWrapperField(this, package_proto_pb.Package, 1));
};


/**
 * @param {?proto.Package|undefined} value
 * @return {!proto.Parcel} returns this
*/
proto.Parcel.prototype.setPackage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.clearPackage = function() {
  return this.setPackage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Parcel.prototype.hasPackage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 id = 2;
 * @return {number}
 */
proto.Parcel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ParcelStatus status = 3;
 * @return {!proto.ParcelStatus}
 */
proto.Parcel.prototype.getStatus = function() {
  return /** @type {!proto.ParcelStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ParcelStatus} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 timeout = 4;
 * @return {number}
 */
proto.Parcel.prototype.getTimeout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setTimeout = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 collapse_key = 5;
 * @return {number}
 */
proto.Parcel.prototype.getCollapseKey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setCollapseKey = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 priority = 6;
 * @return {number}
 */
proto.Parcel.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 send_quality = 7;
 * @return {number}
 */
proto.Parcel.prototype.getSendQuality = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setSendQuality = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 timestamp = 8;
 * @return {number}
 */
proto.Parcel.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional ParcelRetry retry = 9;
 * @return {!proto.ParcelRetry}
 */
proto.Parcel.prototype.getRetry = function() {
  return /** @type {!proto.ParcelRetry} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.ParcelRetry} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setRetry = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional uint32 composite_id = 10;
 * @return {number}
 */
proto.Parcel.prototype.getCompositeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setCompositeId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional ParcelChannel channel = 11;
 * @return {!proto.ParcelChannel}
 */
proto.Parcel.prototype.getChannel = function() {
  return /** @type {!proto.ParcelChannel} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.ParcelChannel} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional uint32 timestamp_millis = 12;
 * @return {number}
 */
proto.Parcel.prototype.getTimestampMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setTimestampMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional ParcelErrorCode error_code = 13;
 * @return {!proto.ParcelErrorCode}
 */
proto.Parcel.prototype.getErrorCode = function() {
  return /** @type {!proto.ParcelErrorCode} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.ParcelErrorCode} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional uint64 backhaul_id = 14;
 * @return {number}
 */
proto.Parcel.prototype.getBackhaulId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setBackhaulId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 flags = 15;
 * @return {number}
 */
proto.Parcel.prototype.getFlags = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setFlags = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 requested_channels = 16;
 * @return {number}
 */
proto.Parcel.prototype.getRequestedChannels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.Parcel} returns this
 */
proto.Parcel.prototype.setRequestedChannels = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.LogCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.LogCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.LogCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LogCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
level: jspb.Message.getFieldWithDefault(msg, 1, 0),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.LogCommand}
 */
proto.LogCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.LogCommand;
  return proto.LogCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.LogCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.LogCommand}
 */
proto.LogCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.LogCommandLevel} */ (reader.readEnum());
      msg.setLevel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.LogCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.LogCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.LogCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LogCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional LogCommandLevel level = 1;
 * @return {!proto.LogCommandLevel}
 */
proto.LogCommand.prototype.getLevel = function() {
  return /** @type {!proto.LogCommandLevel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.LogCommandLevel} value
 * @return {!proto.LogCommand} returns this
 */
proto.LogCommand.prototype.setLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.LogCommand.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.LogCommand} returns this
 */
proto.LogCommand.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.QualityCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.QualityCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.QualityCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QualityCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
level: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.QualityCommand}
 */
proto.QualityCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.QualityCommand;
  return proto.QualityCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.QualityCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.QualityCommand}
 */
proto.QualityCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.QualityCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.QualityCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.QualityCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QualityCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 level = 1;
 * @return {number}
 */
proto.QualityCommand.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.QualityCommand} returns this
 */
proto.QualityCommand.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MobileConnectionQualityCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MobileConnectionQualityCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MobileConnectionQualityCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MobileConnectionQualityCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
confidence: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MobileConnectionQualityCommand}
 */
proto.MobileConnectionQualityCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MobileConnectionQualityCommand;
  return proto.MobileConnectionQualityCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MobileConnectionQualityCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MobileConnectionQualityCommand}
 */
proto.MobileConnectionQualityCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConfidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MobileConnectionQualityCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MobileConnectionQualityCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MobileConnectionQualityCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MobileConnectionQualityCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfidence();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 confidence = 1;
 * @return {number}
 */
proto.MobileConnectionQualityCommand.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MobileConnectionQualityCommand} returns this
 */
proto.MobileConnectionQualityCommand.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.BatteryCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.BatteryCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BatteryCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BatteryCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
percentage: jspb.Message.getFieldWithDefault(msg, 1, 0),
chargeStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BatteryCommand}
 */
proto.BatteryCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BatteryCommand;
  return proto.BatteryCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BatteryCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BatteryCommand}
 */
proto.BatteryCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPercentage(value);
      break;
    case 2:
      var value = /** @type {!proto.ChargeStatus} */ (reader.readEnum());
      msg.setChargeStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BatteryCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.BatteryCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BatteryCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BatteryCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getChargeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint32 percentage = 1;
 * @return {number}
 */
proto.BatteryCommand.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.BatteryCommand} returns this
 */
proto.BatteryCommand.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ChargeStatus charge_status = 2;
 * @return {!proto.ChargeStatus}
 */
proto.BatteryCommand.prototype.getChargeStatus = function() {
  return /** @type {!proto.ChargeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ChargeStatus} value
 * @return {!proto.BatteryCommand} returns this
 */
proto.BatteryCommand.prototype.setChargeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InfoCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.InfoCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InfoCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InfoCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
firmwareversion: jspb.Message.getFieldWithDefault(msg, 1, ""),
imei: jspb.Message.getFieldWithDefault(msg, 2, ""),
trackingon: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
serial: jspb.Message.getFieldWithDefault(msg, 4, ""),
battery: jspb.Message.getFieldWithDefault(msg, 5, 0),
hardwareFlavor: jspb.Message.getFieldWithDefault(msg, 6, 0),
firmwareFlavor: jspb.Message.getFieldWithDefault(msg, 7, 0),
networkCoreVersion: jspb.Message.getFieldWithDefault(msg, 8, ""),
hasLineInCapability: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
supportedRadioRegions: jspb.Message.getFieldWithDefault(msg, 10, 0),
powerSessionUuidMsb: jspb.Message.getFieldWithDefault(msg, 11, 0),
powerSessionUuidLsb: jspb.Message.getFieldWithDefault(msg, 12, 0),
powerStatus: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InfoCommand}
 */
proto.InfoCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InfoCommand;
  return proto.InfoCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InfoCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InfoCommand}
 */
proto.InfoCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareversion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImei(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrackingon(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBattery(value);
      break;
    case 6:
      var value = /** @type {!proto.HardwareFlavor} */ (reader.readEnum());
      msg.setHardwareFlavor(value);
      break;
    case 7:
      var value = /** @type {!proto.FirmwareFlavor} */ (reader.readEnum());
      msg.setFirmwareFlavor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkCoreVersion(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasLineInCapability(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSupportedRadioRegions(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPowerSessionUuidMsb(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPowerSessionUuidLsb(value);
      break;
    case 13:
      var value = /** @type {!proto.PowerStatus} */ (reader.readEnum());
      msg.setPowerStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InfoCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InfoCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InfoCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InfoCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirmwareversion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackingon();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBattery();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getHardwareFlavor();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFirmwareFlavor();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getNetworkCoreVersion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHasLineInCapability();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSupportedRadioRegions();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getPowerSessionUuidMsb();
  if (f !== 0) {
    writer.writeUint64(
      11,
      f
    );
  }
  f = message.getPowerSessionUuidLsb();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getPowerStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional string firmwareVersion = 1;
 * @return {string}
 */
proto.InfoCommand.prototype.getFirmwareversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setFirmwareversion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string imei = 2;
 * @return {string}
 */
proto.InfoCommand.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool trackingOn = 3;
 * @return {boolean}
 */
proto.InfoCommand.prototype.getTrackingon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setTrackingon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string serial = 4;
 * @return {string}
 */
proto.InfoCommand.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 battery = 5;
 * @return {number}
 */
proto.InfoCommand.prototype.getBattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setBattery = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional HardwareFlavor hardware_flavor = 6;
 * @return {!proto.HardwareFlavor}
 */
proto.InfoCommand.prototype.getHardwareFlavor = function() {
  return /** @type {!proto.HardwareFlavor} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.HardwareFlavor} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setHardwareFlavor = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional FirmwareFlavor firmware_flavor = 7;
 * @return {!proto.FirmwareFlavor}
 */
proto.InfoCommand.prototype.getFirmwareFlavor = function() {
  return /** @type {!proto.FirmwareFlavor} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.FirmwareFlavor} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setFirmwareFlavor = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string network_core_version = 8;
 * @return {string}
 */
proto.InfoCommand.prototype.getNetworkCoreVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setNetworkCoreVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool has_line_in_capability = 9;
 * @return {boolean}
 */
proto.InfoCommand.prototype.getHasLineInCapability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setHasLineInCapability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional uint32 supported_radio_regions = 10;
 * @return {number}
 */
proto.InfoCommand.prototype.getSupportedRadioRegions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setSupportedRadioRegions = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint64 power_session_uuid_msb = 11;
 * @return {number}
 */
proto.InfoCommand.prototype.getPowerSessionUuidMsb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setPowerSessionUuidMsb = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint64 power_session_uuid_lsb = 12;
 * @return {number}
 */
proto.InfoCommand.prototype.getPowerSessionUuidLsb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setPowerSessionUuidLsb = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional PowerStatus power_status = 13;
 * @return {!proto.PowerStatus}
 */
proto.InfoCommand.prototype.getPowerStatus = function() {
  return /** @type {!proto.PowerStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.PowerStatus} value
 * @return {!proto.InfoCommand} returns this
 */
proto.InfoCommand.prototype.setPowerStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ActivityCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.ActivityCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ActivityCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ActivityCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
secondstillwake: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ActivityCommand}
 */
proto.ActivityCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ActivityCommand;
  return proto.ActivityCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ActivityCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ActivityCommand}
 */
proto.ActivityCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ActivityStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecondstillwake(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ActivityCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ActivityCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ActivityCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ActivityCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSecondstillwake();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional ActivityStatus status = 1;
 * @return {!proto.ActivityStatus}
 */
proto.ActivityCommand.prototype.getStatus = function() {
  return /** @type {!proto.ActivityStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ActivityStatus} value
 * @return {!proto.ActivityCommand} returns this
 */
proto.ActivityCommand.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 secondsTillWake = 2;
 * @return {number}
 */
proto.ActivityCommand.prototype.getSecondstillwake = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ActivityCommand} returns this
 */
proto.ActivityCommand.prototype.setSecondstillwake = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.HotspotDisconnectedCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.HotspotDisconnectedCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.HotspotDisconnectedCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HotspotDisconnectedCommand.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.HotspotDisconnectedCommand}
 */
proto.HotspotDisconnectedCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.HotspotDisconnectedCommand;
  return proto.HotspotDisconnectedCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.HotspotDisconnectedCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.HotspotDisconnectedCommand}
 */
proto.HotspotDisconnectedCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.HotspotDisconnectedCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.HotspotDisconnectedCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.HotspotDisconnectedCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HotspotDisconnectedCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.RadioDataRateParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.RadioDataRateParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RadioDataRateParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RadioDataRateParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
spreadFactor: jspb.Message.getFieldWithDefault(msg, 1, 0),
bandwidth: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RadioDataRateParameters}
 */
proto.RadioDataRateParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.RadioDataRateParameters;
  return proto.RadioDataRateParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RadioDataRateParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RadioDataRateParameters}
 */
proto.RadioDataRateParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.RadioSpreadFactor} */ (reader.readEnum());
      msg.setSpreadFactor(value);
      break;
    case 2:
      var value = /** @type {!proto.RadioBandwidth} */ (reader.readEnum());
      msg.setBandwidth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.RadioDataRateParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.RadioDataRateParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RadioDataRateParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RadioDataRateParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpreadFactor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBandwidth();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional RadioSpreadFactor spread_factor = 1;
 * @return {!proto.RadioSpreadFactor}
 */
proto.RadioDataRateParameters.prototype.getSpreadFactor = function() {
  return /** @type {!proto.RadioSpreadFactor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.RadioSpreadFactor} value
 * @return {!proto.RadioDataRateParameters} returns this
 */
proto.RadioDataRateParameters.prototype.setSpreadFactor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional RadioBandwidth bandwidth = 2;
 * @return {!proto.RadioBandwidth}
 */
proto.RadioDataRateParameters.prototype.getBandwidth = function() {
  return /** @type {!proto.RadioBandwidth} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.RadioBandwidth} value
 * @return {!proto.RadioDataRateParameters} returns this
 */
proto.RadioDataRateParameters.prototype.setBandwidth = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.HardwareFlavor = {
  HARDWAREFLAVORBASE: 0,
  HARDWAREFLAVORRADIO: 1,
  HARDWAREFLAVORRC2: 2,
  HARDWAREFLAVORRC3: 3,
  HARDWAREFLAVORPC01: 4,
  HARDWAREFLAVORPC02: 5,
  HARDWAREFLAVORPC04: 6
};

/**
 * @enum {number}
 */
proto.FirmwareFlavor = {
  FIRMWAREFLAVORBASE: 0,
  FIRMWAREFLAVORCENTRAL: 1,
  FIRMWAREFLAVORLINEIN: 2
};

/**
 * @enum {number}
 */
proto.CommandType = {
  COMMANDTYPEPARCEL: 0,
  COMMANDTYPELOG: 2,
  COMMANDTYPEQUALITY: 3,
  COMMANDTYPEBATTERY: 5,
  COMMANDTYPEINFO: 6,
  COMMANDTYPESETTINGS: 8,
  COMMANDTYPEACTIVITY: 9,
  COMMANDTYPEQUEUESYNCCOMPLETE: 10,
  COMMANDTYPETRACKING: 11,
  COMMANDTYPEGPSUPDATE: 12,
  COMMANDTYPEFAILURE: 13,
  COMMANDTYPEREGISTRATION: 14,
  COMMANDTYPEALTITUDEREQUEST: 15,
  COMMANDTYPEALTITUDEUPDATE: 16,
  COMMANDTYPESERIALNUMBER: 17,
  COMMANDTYPESERIALNUMBERREQUEST: 18,
  COMMANDTYPERESET: 19,
  COMMANDTYPESTART: 20,
  COMMANDTYPELOWPOWERMODE: 21,
  COMMANDTYPEMAILBOXCHECK: 22,
  COMMANDTYPEPERIPHERAL: 23,
  COMMANDTYPEFACTORYRESET: 24,
  COMMANDTYPEMESHNETWORKUPDATE: 25,
  COMMANDTYPEGPSREQUEST: 26,
  COMMANDTYPEREQUESTDISCONNECT: 27,
  COMMANDTYPEREGISTRATIONUPDATED: 28,
  COMMANDTYPECELLULARSTATUS: 29,
  COMMANDTYPEDATACHUNK: 30,
  COMMANDTYPEGETREGISTRATION: 31,
  COMMANDTYPEGPSHEALTH: 32,
  COMMANDTYPEMESHFILEINITREQUEST: 33,
  COMMANDTYPEMESHFILEINITRESPONSE: 34,
  COMMANDTYPEMESHFILEBLOCKPART: 35,
  COMMANDTYPEMESHFILEBLOCKTXDONE: 36,
  COMMANDTYPEMESHFILEINITIATED: 37,
  COMMANDTYPEMESHFILEINITIATEDACK: 38,
  COMMANDTYPEMOBILECONNECTIONQUALITY: 39,
  COMMANDTYPEVITALSCHECKSTART: 40,
  COMMANDTYPEVITALSCHECKUPDATE: 41,
  COMMANDTYPECONFIRMDEVICEFORWARD: 42,
  COMMANDTYPEDEVICEFORWARD: 43,
  COMMANDTYPEVITALSCHECKPEEK: 44,
  COMMANDTYPEVITALSCHECKSTOP: 45,
  COMMANDTYPEFACTORY: 46,
  COMMANDTYPEENTERBOOTLOADERMODE: 47,
  COMMANDTYPEGETSETTINGS: 48,
  COMMANDTYPEGETINFO: 49,
  COMMANDTYPEGETBATTERY: 50,
  COMMANDTYPEFLASHLOGFILE: 51,
  COMMANDTYPEMESHNEIGHBORUPDATE: 52,
  COMMANDTYPEMESHCMDGET: 53,
  COMMANDTYPEMESHCMDSET: 54,
  COMMANDTYPEMESHCMDREPORT: 55,
  COMMANDTYPEDEVICEPOWERONOFF: 56,
  COMMANDTYPEFACTORYDEFAULTSETTINGS: 57
};

/**
 * @enum {number}
 */
proto.ParcelStatus = {
  PARCELSTATUSNONE: 0,
  PARCELSTATUSCONNECTING: 1,
  PARCELSTATUSSENDING: 2,
  PARCELSTATUSDELIVERED: 3,
  PARCELSTATUSERROR: 4,
  PARCELSTATUSQUEUED: 5,
  PARCELSTATUSCANCELED: 6,
  PARCELSTATUSCOLLAPSED: 7,
  PARCELSTATUSPENDINGTRANSFER: 8,
  PARCELSTATUSTRANSFERRING: 9
};

/**
 * @enum {number}
 */
proto.ParcelRetry = {
  PARCELRETRYNEVER: 0,
  PARCELRETRYAFTERTIMEOUT: 1
};

/**
 * @enum {number}
 */
proto.ParcelChannel = {
  PARCELCHANNELNONE: 0,
  PARCELCHANNELSATELLITE: 1,
  PARCELCHANNELRADIO: 2,
  PARCELCHANNELMESH: 3,
  PARCELCHANNELAUTO: 4,
  PARCELCHANNELBROADCAST: 5,
  PARCELCHANNELCELLULAR: 6,
  PARCELCHANNELENDUSERDEVICE: 7
};

/**
 * @enum {number}
 */
proto.ParcelErrorCode = {
  PARCELERRORCODENONE: 0,
  PARCELERRORCODEBACKHAULTIMEOUT: 1,
  PARCELERRORCODETIMEOUT: 2,
  PARCELERRORCODEDISABLED: 3,
  PARCELERRORCODENOMEMORY: 4
};

/**
 * @enum {number}
 */
proto.LogCommandLevel = {
  LOGCOMMANDLEVELTRACE: 0,
  LOGCOMMANDLEVELDEBUG: 1,
  LOGCOMMANDLEVELINFO: 2,
  LOGCOMMANDLEVELWARN: 3,
  LOGCOMMANDLEVELERROR: 4
};

/**
 * @enum {number}
 */
proto.ChargeStatus = {
  CHARGESTATUSNONE: 0,
  CHARGESTATUSCHARGING: 1,
  CHARGESTATUSNOTCHARGING: 2,
  CHARGESTATUSHARDWAREFAULT: 3
};

/**
 * @enum {number}
 */
proto.PowerStatus = {
  POWERSTATUSNONE: 0,
  POWERSTATUSON: 1,
  POWERSTATUSDEEPSLEEP: 2
};

/**
 * @enum {number}
 */
proto.ActivityStatus = {
  ACTIVITYSTATUSNONE: 0,
  ACTIVITYSTATUSSLEEPING: 1,
  ACTIVITYSTATUSSENDING: 2,
  ACTIVITYSTATUSLISTENING: 3,
  ACTIVITYSTATUSRECEIVING: 4,
  ACTIVITYSTATUSONLINE: 5
};

/**
 * @enum {number}
 */
proto.RadioMode = {
  RADIOMODENONE: 0,
  RADIOMODEDISABLED: 1,
  RADIOMODEENABLED: 2,
  RADIOMODESTEALTH: 3
};

/**
 * @enum {number}
 */
proto.RadioPowerMode = {
  RADIOPOWERMODENONE: 0,
  RADIOPOWERMODELOW: 1,
  RADIOPOWERMODEMEDIUM: 2,
  RADIOPOWERMODEHIGH: 3
};

/**
 * @enum {number}
 */
proto.ButtonFunction = {
  BUTTONFUNCTIONNONE: 0,
  BUTTONFUNCTIONSAT: 1,
  BUTTONFUNCTIONTRACKING: 2,
  BUTTONFUNCTIONSENSOR: 3
};

/**
 * @enum {number}
 */
proto.MeshVersion = {
  MESHVERSIONNONE: 0,
  MESHVERSION0: 1,
  MESHVERSION1: 2
};

/**
 * @enum {number}
 */
proto.RadioSpreadFactor = {
  RADIOSPREADFACTORNONE: 0,
  RADIOSPREADFACTOR05: 1,
  RADIOSPREADFACTOR06: 2,
  RADIOSPREADFACTOR07: 3,
  RADIOSPREADFACTOR08: 4,
  RADIOSPREADFACTOR09: 5,
  RADIOSPREADFACTOR10: 6,
  RADIOSPREADFACTOR11: 7,
  RADIOSPREADFACTOR12: 8
};

/**
 * @enum {number}
 */
proto.RadioBandwidth = {
  RADIOBANDWIDTHNONE: 0,
  RADIOBANDWIDTH007KHZ: 1,
  RADIOBANDWIDTH010KHZ: 2,
  RADIOBANDWIDTH015KHZ: 3,
  RADIOBANDWIDTH020KHZ: 4,
  RADIOBANDWIDTH031KHZ: 5,
  RADIOBANDWIDTH041KHZ: 6,
  RADIOBANDWIDTH062KHZ: 7,
  RADIOBANDWIDTH125KHZ: 8,
  RADIOBANDWIDTH250KHZ: 9,
  RADIOBANDWIDTH500KHZ: 10
};

/**
 * @enum {number}
 */
proto.RadioRegion = {
  RADIOREGIONNONE: 0,
  RADIOREGIONUNLOCKED: 1,
  RADIOREGIONUSLEGACY: 2,
  RADIOREGIONEULEGACY: 3,
  RADIOREGIONUS: 4,
  RADIOREGIONEU: 5,
  RADIOREGIONAU: 6,
  RADIOREGIONJP: 7,
  RADIOREGIONIN: 8
};

/**
 * @enum {number}
 */
proto.MeshCmdDataType = {
  MESHCMDDATATYPENONE: 0,
  MESHCMDDATATYPESETTINGS: 1,
  MESHCMDDATATYPEMESHNETWORKUPDATES: 2
};

/**
 * @enum {number}
 */
proto.MeshCmdTypeTriggeredReport = {
  MESHCMDTYPETRIGGEREDREPORTNONE: 0,
  MESHCMDTYPETRIGGEREDREPORTGET: 1,
  MESHCMDTYPETRIGGEREDREPORTSET: 2
};

goog.object.extend(exports, proto);
